import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import moment from "moment";
import UpdateServiceTask from "../Services/UpadateServiceTask";
import ServiceTaskComments from "../Services/ServiceTaskComments";
import DocumentModal from "../Client-Info/DocumentModel";
import config from "../../Common/Configurations/APIConfig";
import Select from "react-select";

const YourTasks = ({ headerconfig, clients, categories }) => {
  const [filterValues, setFilterValues] = useState({
    clientId: "00000000-0000-0000-0000-000000000000",
    categoryId: "00000000-0000-0000-0000-000000000000",
    month: new Date(),
    status: "",
  });
  const [yourTasks, setYourTasks] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [documentModalVisible, setDocumentModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [commentsModalVisible, setCommentsModalVisible] = useState(false);
  const [currentServiceTask, setCurrentServiceTask] = useState(null);
  const [errors, setErrors] = useState({});
  const staffId = localStorage.getItem("staffId");
  const userId = localStorage.getItem("userId");

  const handlefilterChange = (e) => {
    const { name, value } = e.target;
    setFilterValues({
      ...filterValues,
      [name]: value,
    });
  };

  const handleSearch = () => {
    GetYourTasks(pageNumber);
  };

  const handleclear = () => {
    setFilterValues({
      clientId: "00000000-0000-0000-0000-000000000000",
      categoryId: "00000000-0000-0000-0000-000000000000",
      month: new Date(),
      status: "",
    });
    GetYourTasks(pageNumber);
  };
  const handleUpdateSuccess = () => {
    GetYourTasks(pageNumber); // Refresh the task list
  };

  const toggleEditModal = (serviceTask) => {
    setCurrentServiceTask(serviceTask);
    setEditModalVisible(!editModalVisible);
  };

  const toggleDocumentModal = (serviceTask) => {
    setCurrentServiceTask(serviceTask);
    setDocumentModalVisible(!documentModalVisible);
  };

  const GetPageData = (number) => {
    if (number >= 1 && number <= totalPages) {
      setPageNumber(number);
      GetYourTasks(number);
    }
  };
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });
  const GetYourTasks = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETYOURSERVICETASK +
          "?userId=" +
          userId +
          "&pageNumber=" +
          number +
          "&pageSize=" +
          pageSize +
          "&staffId=" +
          staffId +
          "&clientId=" +
          filterValues.clientId +
          "&categoryId=" +
          filterValues.categoryId +
          "&month=" +
          moment(filterValues.month).format("YYYY-MM") +
          "&status=" +
          filterValues.status,
        { ...headerconfig }
      )
      .then((response) => {
        setYourTasks(response.data.data.data);
        setPageNumber(response.data.data.pageNumber);
        setPageSize(response.data.data.pageSize);
        setTotalPages(response.data.data.totalPages);
        setTotalRecords(response.data.data.totalRecords);
      });
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  useEffect(() => {
    GetYourTasks(pageNumber);
  }, []);

  return (
    <div className="row mt-4">
      <div className="col-xl-12">
        <div className="alert alert-success">
          <form autoComplete="off" noValidate>
            <div className="row">
              <div className="col-lg-3">
                <div className="mb-3">
                  <label>Client</label>
                  <Select
                    name="clientId"
                    value={
                      clients.find((c) => c.clientId === filterValues.clientId)
                        ? {
                            value: filterValues.clientId,
                            label:
                              clients.find(
                                (c) => c.clientId === filterValues.clientId
                              )?.clientName || "All",
                          }
                        : null
                    }
                    onChange={(selectedOption) =>
                      setFilterValues({
                        ...filterValues,
                        clientId: selectedOption
                          ? selectedOption.value
                          : "00000000-0000-0000-0000-000000000000",
                      })
                    }
                    options={[
                      {
                        value: "00000000-0000-0000-0000-000000000000",
                        label: "All",
                      },
                      ...clients.map((c) => ({
                        value: c.clientId,
                        label: c.clientName,
                      })),
                    ]}
                    isSearchable
                    placeholder="Select Client"
                  />
                </div>
              </div>

              <div className="col-lg-3">
                <div className="mb-3">
                  <label>Category</label>
                  <select
                    name="categoryId"
                    value={filterValues.categoryId}
                    onChange={handlefilterChange}
                    className="form-select"
                  >
                    <option value="00000000-0000-0000-0000-000000000000">
                      All
                    </option>
                    {categories.map((cat) => (
                      <option key={cat.categoryId} value={cat.categoryId}>
                        {cat.categoryName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="mb-3">
                  <label>Month</label>
                  <div className="input-group">
                    <Flatpickr
                      value={filterValues.month}
                      className="form-control"
                      options={{
                        dateFormat: "Y-m",
                        plugins: [
                          new (require("flatpickr/dist/plugins/monthSelect"))({
                            shorthand: true,
                            dateFormat: "M-Y",
                            theme: "light",
                          }),
                        ],
                      }}
                      onChange={(date) =>
                        setFilterValues({ ...filterValues, month: date[0] })
                      }
                    />
                    <div className="input-group-text bg-primary border-primary text-white">
                      <i className="ri-calendar-2-line" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="mb-3">
                  <label htmlFor="status" className="form-label">
                    Status
                  </label>
                  <select
                    name="status"
                    value={filterValues.status}
                    onChange={handlefilterChange}
                    className="form-select"
                  >
                    <option value="">All</option>
                    <option value="COMPLETED">COMPLETED</option>
                    <option value="PENDING">PENDING</option>
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="hstack gap-2 justify-content-middle mb-3 mt-4">
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger w-100"
                    onClick={handleclear}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card card-height-100">
              <div className="card-header align-items-center d-flex">
                <h4 className="card-title mb-0 flex-grow-1">Your Tasks</h4>
              </div>
              <div className="card-body">
                <div className="table-responsive table-card">
                  <table className="table align-middle" id="yourTaskTable">
                    <thead className="table-light">
                      <tr>
                        <th>S.No</th>
                        <th>Client</th>
                        <th>Service</th>
                        <th>Service Month</th>
                        <th>Cycle</th>
                        <th>Service Status</th>
                        <th>Created Date</th>
                        <th>Updated Date</th>
                        <th>Upload Documents</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody className="list form-check-all">
                      {yourTasks.length > 0 ? (
                        yourTasks.map((v, index) => (
                          <tr key={v.serviceTaskId}>
                            <td>{(pageNumber - 1) * pageSize + (index + 1)}</td>
                            <td>{v.clientName}</td>
                            <td>{v.serviceName}</td>
                            <td>{moment(v.month).format("MMM-YYYY")}</td>
                            <td>{v.cycle}</td>
                            <td>
                              <span
                                className={
                                  "badge " +
                                  (v.status === "COMPLETED"
                                    ? "bg-success"
                                    : "bg-warning")
                                }
                              >
                                {v.status}
                              </span>
                            </td>
                            <td>
                              {moment(v.createdDate).format(
                                "DD MMM YY hh:mm a"
                              )}
                            </td>
                            <td>
                              {moment(v.lastUpdatedDate).format(
                                "DD MMM YY hh:mm a"
                              )}
                            </td>
                            <td>
                              <ul className="list-inline hstack gap-2 mb-0">
                                <li onClick={() => toggleDocumentModal(v)}>
                                  <i className="fas fa-file-alt"></i>
                                </li>
                              </ul>
                            </td>

                            <td>
                              <ul className="list-inline hstack gap-2 mb-0">
                                <li
                                  className="list-inline-item"
                                  data-bs-toggle="tooltip"
                                  title="Edit"
                                >
                                  <Link
                                    className="text-primary"
                                    onClick={() => toggleEditModal(v)}
                                  >
                                    <i className="ri-pencil-fill fs-16" />
                                  </Link>
                                </li>
                                <li
                                  className="list-inline-item"
                                  data-bs-toggle="tooltip"
                                  title="Comments"
                                >
                                  <Link
                                    className="text-secondary"
                                    onClick={() => {
                                      setCurrentServiceTask(v);
                                      setCommentsModalVisible(true);
                                    }}
                                  >
                                    <i className="ri-chat-3-fill fs-16" />
                                  </Link>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="10" className="text-center">
                            Not Available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                  <div className="flex-shrink-0">
                    <div className="text-muted">
                      Showing{" "}
                      <span className="fw-semibold">{yourTasks.length}</span> of{" "}
                      <span className="fw-semibold">{totalRecords}</span>{" "}
                      Results
                    </div>
                  </div>
                  <ul className="pagination pagination-separated pagination-sm mb-0">
                    <li
                      className={
                        "page-item " + (pageNumber === 1 ? "disabled" : "")
                      }
                      onClick={() => GetPageData(pageNumber - 1)}
                    >
                      <Link className="page-link">Previous</Link>
                    </li>
                    {renderPageNumbers}
                    <li
                      className={
                        "page-item " +
                        (pageNumber === totalPages ? "disabled" : "")
                      }
                      onClick={() => GetPageData(pageNumber + 1)}
                    >
                      <Link className="page-link">Next</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {documentModalVisible && (
          <DocumentModal
            currentServiceTask={currentServiceTask}
            setDocumentModalVisible={setDocumentModalVisible}
            headerconfig={headerconfig}
          />
        )}

        {editModalVisible && (
          <UpdateServiceTask
            onClose={() => setEditModalVisible(false)}
            headerconfig={headerconfig}
            serviceTask={currentServiceTask}
            onUpdateSuccess={handleUpdateSuccess}
          />
        )}

        {commentsModalVisible && (
          <ServiceTaskComments
            serviceTaskId={currentServiceTask?.serviceTaskId}
            onClose={() => setCommentsModalVisible(false)}
            headerconfig={headerconfig}
          />
        )}
      </div>
    </div>
  );
};

export default YourTasks;
